// import React, { useEffect, useState } from "react";
// import styling from "./MyStocks.module.css";
// import { useSelector, useDispatch } from "react-redux";
// import { notify, ToastContainer } from "../../../Notify/Notify";
// import { FiEdit2 } from "react-icons/fi";
// import { AiOutlineDelete } from "react-icons/ai";
// import EditMyStock from "./EditMyStock/EditMyStock";
// import firebase from "../../../../firebase/firebase";
// import { salesItem } from "../../../../redux/actions/actions";

// function MyStocks({ guestUser }) {
//   let [items, setItems] = useState([]);
//   let [editStock, setEditStock] = useState(false);
//   let [itemDetails, setItemDetails] = useState([]);
//   let allItems = useSelector((state) => state.salesItem);
//   let userInfo = useSelector((state) => state.user);
//   let dispatch = useDispatch();

//   let toggleEditScreen = (details) => {
//     setEditStock(!editStock);

//     if (details === "added") {
//       notify("success", "Edited item successfully");
//     } else if (details) {
//       setItemDetails(details);
//     }
//   };

//   useEffect(() => {
//     let localArr = [];
//     for (let item of Object.entries(allItems)) {
//       localArr.push(item);
//     }
//     localArr = localArr.sort((a, b) => {
//       if (a[0] < b[0]) {
//         return -1;
//       }
//       if (a[0] > b[0]) {
//         return 1;
//       }
//       return 0;
//     });
//     setItems(localArr);
//   }, [allItems]);

//   let deleteItem = (details) => {
//     if (window.confirm("Are you sure you want to delete this item ?")) {
//       delete allItems[details.itemName];
//       let products = { ...allItems };

//       const db = firebase.firestore();
//       db.collection("shops")
//         .doc(userInfo.shopName)
//         .update({
//           products,
//         })
//         .then(() => {
//           dispatch(salesItem({ ...allItems }));
//           notify("success", "Deleted item successfully");
//           console.log("Deleted data successfully");
//         })
//         .catch((error) => {
//           console.error("Error adding document: ", error);
//           notify("success", "Error occured");
//         });
//     }
//   };

//   return (
//     <>
//       <div className={styling.MyStocks}>
//         {items.length ? (
//           <table cellspacing="0">
//             <thead>
//               <tr>
//                 <th>S. No.</th>
//                 <th>Item Name</th>
//                 <th>Quantity</th>
//                 <th>Cost Price</th>
//                 <th>Selling Price</th>
//                 {userInfo.status === "admin" || guestUser ? (
//                   <th>Action</th>
//                 ) : null}
//               </tr>
//               {items.map((each, count) => (
//                 <tr>
//                   <td>{count + 1}</td>
//                   <td>{each[0]}</td>
//                   <td>
//                     {each[1].quantity} {each[1].measurment}
//                   </td>
//                   <td>{each[1].costPrice}</td>
//                   <td>{each[1].sellingPrice}</td>
//                   {userInfo.status === "admin" || guestUser ? (
//                     <td>
//                       <FiEdit2
//                         className={`${styling.editIcon}  ${
//                           guestUser && "guestUserGrey"
//                         }`}
//                         onClick={() => {
//                           !guestUser && toggleEditScreen(each[1]);
//                         }}
//                       />
//                       <AiOutlineDelete
//                         className={`${styling.deleteIcon}  ${
//                           guestUser && "guestUserGrey"
//                         }`}
//                         onClick={() => !guestUser && deleteItem(each[1])}
//                       />
//                     </td>
//                   ) : null}
//                 </tr>
//               ))}
//             </thead>
//           </table>
//         ) : (
//           <h2>No Item is added</h2>
//         )}
//       </div>
//       {editStock ? (
//         <EditMyStock
//           toggleEditScreen={toggleEditScreen}
//           itemDetails={itemDetails}
//         />
//       ) : null}
//       <ToastContainer />
//     </>
//   );
// }

// export default MyStocks;
import React, { useEffect, useState } from "react";
import styling from "./MyStocks.module.css";
import { useSelector, useDispatch } from "react-redux";
import { notify, ToastContainer } from "../../../Notify/Notify";
import { FiEdit2 } from "react-icons/fi";
import { AiOutlineDelete } from "react-icons/ai";
import EditMyStock from "./EditMyStock/EditMyStock";
import firebase from "../../../../firebase/firebase";
import { salesItem } from "../../../../redux/actions/actions";

function MyStocks({ guestUser }) {
  const [items, setItems] = useState([]);
  const [editStock, setEditStock] = useState(false);
  const [itemDetails, setItemDetails] = useState([]);
  const allItems = useSelector((state) => state.salesItem);
  const userInfo = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const toggleEditScreen = (details) => {
    setEditStock((prev) => !prev);

    if (details === "added") {
      notify("success", "Edited item successfully");
    } else if (details) {
      setItemDetails(details);
    }
  };

  useEffect(() => {
    let localArr = [];
    for (let item of Object.entries(allItems)) {
      localArr.push(item);
    }

    localArr = localArr.sort((a, b) => a[0].localeCompare(b[0]));
    setItems(localArr);
  }, [allItems]);

  const deleteItem = (details) => {
    if (window.confirm("Are you sure you want to delete this item?")) {
      delete allItems[details.itemName];
      const products = { ...allItems };

      const db = firebase.firestore();
      db.collection("shops")
        .doc(userInfo.shopName)
        .update({ products })
        .then(() => {
          dispatch(salesItem({ ...allItems }));
          notify("success", "Deleted item successfully");
        })
        .catch((error) => {
          console.error("Error adding document: ", error);
          notify("error", "Error occurred");
        });
    }
  };

  const showActions = userInfo.status === "admin" || guestUser;

  return (
    <>
      <div className={styling.MyStocks}>
        {items.length ? (
          <div className={styling.tableCard}>
            <div className={styling.tableHeader}>
              <h2>My Stocks</h2>
              <span className={styling.tableMeta}>
                {items.length} item{items.length > 1 ? "s" : ""}
              </span>
            </div>

            <div className={styling.tableWrapper}>
              <table cellSpacing="0">
                <thead>
                  <tr>
                    <th>S. No.</th>
                    <th>Item Name</th>
                    <th>Quantity</th>
                    <th>Cost Price</th>
                    <th>Selling Price</th>
                    {showActions && <th>Action</th>}
                  </tr>
                </thead>
                <tbody>
                  {items.map((each, index) => (
                    <tr key={each[0]}>
                      <td>{index + 1}</td>
                      <td>{each[0]}</td>
                      <td>
                        {each[1].quantity} {each[1].measurment}
                      </td>
                      <td>{each[1].costPrice}</td>
                      <td>{each[1].sellingPrice}</td>
                      {showActions && (
                        <td className={styling.actionCell}>
                          <button
                            type="button"
                            className={`${styling.iconButton} ${
                              guestUser && "guestUserGrey"
                            }`}
                            onClick={() =>
                              !guestUser && toggleEditScreen(each[1])
                            }
                            title={guestUser ? "Sign in to edit" : "Edit item"}
                          >
                            <FiEdit2 className={styling.editIcon} />
                          </button>
                          <button
                            type="button"
                            className={`${styling.iconButton} ${
                              guestUser && "guestUserGrey"
                            }`}
                            onClick={() => !guestUser && deleteItem(each[1])}
                            title={
                              guestUser ? "Sign in to delete" : "Delete item"
                            }
                          >
                            <AiOutlineDelete className={styling.deleteIcon} />
                          </button>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {guestUser && (
              <p className={styling.guestInfo}>
                You’re in demo mode. Sign in to edit or delete stock items.
              </p>
            )}
          </div>
        ) : (
          <div className={styling.emptyState}>
            <h2>No items added yet</h2>
            <p>
              Add your first product in the <strong>Add Item</strong> section to
              see it here.
            </p>
          </div>
        )}
      </div>

      {editStock && (
        <EditMyStock
          toggleEditScreen={toggleEditScreen}
          itemDetails={itemDetails}
        />
      )}
      <ToastContainer />
    </>
  );
}

export default MyStocks;
